export default "__VITE_ASSET__a50a68d7__"